import axiosInstance from "../../../util/axiosInstance";
import config from "../../../config";

// Extracts "HH:MM:SS" from a Date object/string. Returns undefined if invalid/missing,
// so the field is safely omitted from the request body rather than sent as garbage.
const extractTime = (dateVal) => {
  if (!dateVal) return undefined;
  const d = new Date(dateVal);
  if (isNaN(d)) return undefined;
  return d.toTimeString().slice(0, 8); // "HH:MM:SS"
};

export const createEvent = async (evdata) => {

  console.log("Event Creation is called ", evdata);

  var evbody = evdata
    ? {
      eventTitle: evdata.eventTitle,
      eventType: evdata.event?.event,
      eventId: evdata.event?.id,
      description: evdata.eventDesc,
      startDate: evdata.Date,
      venue: evdata.Address,
      endDate: evdata.EndDate,           // FIXED: was evdata.endDate (wrong case)
      startTime: extractTime(evdata.Date),
      endTime: extractTime(evdata.EndDate),
      locationLat: evdata.locationLat,
      locationLong: evdata.locationLong,
      area: evdata.area,
      city: evdata.city,
      state: evdata.state,
    }
    : {};
  console.log("event body:", evbody);
  try {
    console.log(
      "Current Axios instance headers:",
      axiosInstance.defaults.headers
    );

    const response = await axiosInstance.post("/my-events", evbody);
    const data = await response.data;
    if (response.status === 200 || response.status === 201) {
      return data;
    } else {
      throw Error(data.message || "Failed to create event");
    }
  } catch (ex) {
    console.log("failed to create event:", ex);
  }
};

export const updateEvent = async (evdata, eventid) => {
  // const evdata = JSON.parse(eventPrms);
  console.log("Event Creation is called ", evdata);
  var evbody = evdata
    ? {
      description: evdata.eventDesc,
      startDate: evdata.Date,
      venue: evdata.Address,
      endDate: evdata.EndDate,           // FIXED: was evdata.endDate (wrong case)
      startTime: extractTime(evdata.Date),
      endTime: extractTime(evdata.EndDate),
      locationLat: evdata.locationLat,
      locationLong: evdata.locationLong,
      area: evdata.area,
      city: evdata.city,
      state: evdata.state,
      invitedBy: evdata.invitedBy,
      imagePath: evdata.imagePath,
    }
    : {};
  console.log("event body:", evbody);
  try {
    console.log(
      "Current Axios instance headers:",
      axiosInstance.defaults.headers
    );

    const response = await axiosInstance.put(`/my-events/${eventid}`, evbody);
    const data = await response.data;
    if (response.status === 200) {
      console.log("event resps:", data.event);
      return true;
    } else {
      throw Error(data.message || "Failed to create event");
    }
  } catch (ex) {
    console.log("failed to create event:", ex);
    return false;
  }
};

// const postEvent = async () => {
//   console.log("create event");
//   const eventBody = localStorage.getItem(config.eventLocalStorageKey);
//   console.log(eventBody);
//   if (eventBody) {
//     await createEvent(eventBody);
//     localStorage.removeItem(config.eventLocalStorageKey);
//   }
// };